import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'phonebook-row-checkbox',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    template: `
    <div class="tw-p-0">
      <div class="form-check tw-flex-center tw-mb-0 tw-ml-1">
        <!--! [attr.data-checkbox-id]="item.id" -->
        <input
          #checkboxElement
          type="checkbox"
          class="form-check-input tw-ml-0.5 "
          style="margin-right:5px !important;"
          [(ngModel)]="value"
          [disabled]="disabled"
          [indeterminate]="indeterminate"
          (change)="onChange()"
        />
      </div>
    </div>
  `
})
export class PhonebookRowCheckboxComponent {
  @Input() disabled: boolean;
  @Input() value: boolean;
  @Input() indeterminate: boolean;
  @Output() valueChange = new EventEmitter<boolean>();
  onChange() {
    this.valueChange.emit(this.value);
  }
}
